import React from 'react';
import '../../pages/fabrisorb-deco/slider-fabrisorb-deco.css';
import Banner1 from '../../images/newproductslider/Fabrisorb-DECO1.webp';
import Banner2 from '../../images/newproductslider/Fabrisorb-DECO2.webp';
import Banner3 from '../../images/newproductslider/Fabrisorb-DECO3.webp';
import Banner4 from '../../images/newproductslider/Fabrisorb-DECO4.webp';
function SliderFabrisorbDeco() {
    return (

        <>
            <div id="slider-fabrisorb-deco">
                <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                    <ol className="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                    </ol>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img className="d-block w-100" src={Banner1} alt="Ceiling Panels" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Fabrisorb Deco Panels</h2>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="d-block w-100" src={Banner2} alt="Designer Panels" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Fabrisorb Deco Panels</h2>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="d-block w-100" src={Banner3} alt="Wall Panels " />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Fabrisorb Deco Panels</h2>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="d-block w-100" src={Banner4} alt="Ceiling Baffles" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Fabrisorb Deco Panels</h2>
                            </div>
                        </div>
                    </div>
                    <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </>
    );
}
export default SliderFabrisorbDeco;